import { Grid } from '@material-ui/core';
import { ContatoForm } from 'app/main/pessoa/Contato';
import React from 'react';

function ContatoTab() {
  return (
    <Grid container spacing={3} className="mt-10">
      <ContatoForm />
    </Grid>
  );
}

export default ContatoTab;
